export const strSemEspacoEmBrancoECaracteresEspeciais = value => /^[a-zA-Z0-9]+$/.test(String(value)) || 'O campo não pode ter espaços em branco e caracteres especiais'

export function cepRequired() {
  return 'Cep inválido.'
}

// Não utilizada no momento
export function isEmailValido(email) {
  if (!email) return false

  const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

  return emailRegex.test(email)
}

export function isCpfValido(cpf) {
  if (typeof cpf !== 'string') return 'Digite um CPF válido'

  cpf = cpf.replace(/[\s.-]*/gim, '')

  if (cpf.length !== 11 || !Array.from(cpf).filter(e => e !== cpf[0]).length) {
    return 'Digite um cpf válido'
  }

  let soma = 0
  let resto

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i)
  }

  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(cpf.substring(9, 10), 10)) return 'Digite um CPF válido'

  soma = 0

  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i)
  }

  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(cpf.substring(10, 11), 10)) return 'Digite um CPF válido'

  return true
}

export function isCnpjValido(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '')

  if (cnpj === '') return false

  if (cnpj.length !== 14) return false

  // Elimina CNPJs invalidos conhecidos
  if (cnpj.length !== 14 || !Array.from(cnpj).filter(e => e !== cnpj[0]).length) {
    return 'Digite um cnpj válido'
  }

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)

  const digitos = cnpj.substring(tamanho)

  let soma = 0
  let pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== digitos.charAt(0)) return 'Digite um CNPJ válido'

  tamanho += 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)

  if (resultado !== digitos.charAt(1)) return 'Digite um CNPJ válido'

  return true
}

export function isTelefoneCelularValido(telefone) {
  if (!telefone) return ''

  // retira todos os caracteres menos os numeros.
  telefone = telefone.replace(/\D/g, '')

  // verifica se tem a qtd de numero correto.
  if (!(telefone.length >= 10 && telefone.length <= 11)) return 'Digite um telefone válido'

  // Se tiver 11 caracteres, verificar se começa com 9 o celular.
  if (telefone.length === 11 && parseInt(telefone.substring(2, 3), 10) !== 9) return 'Digite um telefone válido'

  if (
    (telefone.length === 11 && parseInt(telefone.substring(3, 4), 10) === 0)
  ) {
    return 'Digite um telefone válido'
  }

  // verifica se não é nenhum numero digitado errado.
  for (let n = 0; n < 10; n++) {
    if (telefone === new Array(11).join(n) || telefone === new Array(12).join(n)) return 'Digite um telefone válido'
  }

  // DDDs validos
  const codigosDDD = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48,
    49, 51, 53, 54, 55, 61, 62, 64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
    91, 92, 93, 94, 95, 96, 97, 98, 99,
  ]

  // verifica se o DDD é valido
  if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2), 10)) === -1) return 'Digite um telefone válido'

  //  E por ultimo verificar se o numero é realmente válido.
  if (new Date().getFullYear() < 2017) return true
  if (telefone.length === 10 && [4, 5, 6, 7, 8, 9].indexOf(parseInt(telefone.substring(2, 3), 10)) === -1) {
    return 'Digite um telefone válido'
  }

  // se passar por todas as validações acima, então está tudo certo.
  return true
}

export function isTelefoneFixoValido(telefone) {
  // retira todos os caracteres menos os numeros.
  telefone = telefone.replace(/\D/g, '')

  // verifica se tem a qtd de numero correto.
  if (!(telefone.length >= 10 && telefone.length <= 10)) return 'Digite um telefone válido'

  // verifica se não é nenhum numero digitado errado.
  for (let n = 0; n < 10; n++) {
    if (telefone === new Array(10).join(n) || telefone === new Array(11).join(n)) return 'Digite um telefone válido'
  }

  // DDDs validos
  const codigosDDD = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48,
    49, 51, 53, 54, 55, 61, 62, 64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
    91, 92, 93, 94, 95, 96, 97, 98, 99,
  ]

  // verifica se o DDD é valido
  if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2), 10)) === -1) return 'Digite um telefone válido'

  //  E por ultimo verificar se o numero é realmente válido.
  if (new Date().getFullYear() < 2017) return true
  if (telefone.length === 10 && [2, 3, 4, 5, 6].indexOf(parseInt(telefone.substring(2, 3), 10)) === -1) {
    return 'Digite um telefone válido'
  }

  // se passar por todas as validações acima, então está tudo certo.

  return true
}
